import { useEffect } from 'react';

const ServerOptimization = () => {
  useEffect(() => {
    // Optimize images
    const optimizeImages = () => {
      const images = document.querySelectorAll('img');
      images.forEach(img => {
        if (!img.loading) {
          img.loading = 'lazy';
        }
        if (!img.decoding) {
          img.decoding = 'async';
        }
      });
    };


    // Optimize fonts
    const optimizeFonts = () => {
      const fontLink = document.createElement('link');
      fontLink.rel = 'preconnect';
      fontLink.href = 'https://fonts.googleapis.com';
      document.head.appendChild(fontLink);

      const fontLink2 = document.createElement('link');
      fontLink2.rel = 'preconnect';
      fontLink2.href = 'https://fonts.gstatic.com';
      fontLink2.crossOrigin = 'anonymous';
      document.head.appendChild(fontLink2);
    };

    // Minimize DOM operations
    const optimizeDOM = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      });

      document.querySelectorAll('[data-animate]').forEach(el => {
        observer.observe(el);
      });
    };

    optimizeImages();
    optimizeFonts();
    optimizeDOM();

    // Cleanup on unmount
    return () => {
      // Cleanup if needed
    };
  }, []);

  return null;
};

export default ServerOptimization;